import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { COVERAGE_AREAS } from '../../data/mockData';

const QuickSearches = () => {
  const cities = COVERAGE_AREAS.filter(a => a.type === 'city');

  return (
    <section className="py-16 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Quick <span className="text-red-500">Searches</span>
          </h2>
          <p className="text-gray-400">Browse homes in our service areas</p>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4 text-red-500 flex items-center gap-2">
            <MapPin size={18} />
            Cities We Serve
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
            {cities.map((area) => (
              <Link
                key={area.id}
                to={`/search?location=${area.id}`}
                className="flex items-center justify-between p-3 bg-gray-800 rounded-lg hover:bg-red-600 transition-colors group"
              >
                <span>Homes in {area.name}</span>
                <ArrowRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickSearches;
